import React from 'react'
import { useAgTechQueryCombination } from '@agtech/core/data/queries/AgTechDataQueries';
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface';
import OperationLogo from '../logo/OperationLogo';
import { OperationDataGetOperationInfoQuery, OperationDataGetOperationLogoQuery } from '@agtech/data/operations/OperationDataQueries';

const OperationSideNavigationInfo = () => {
    const operationDataQuery = useAgTechQueryCombination({
        firstQuery: {
            query: OperationDataGetOperationInfoQuery
        },
        secondQuery: {
            query: OperationDataGetOperationLogoQuery
        },
        projection: (operationInfo, operationLogo) => ({
            ...operationInfo,
            logo: operationLogo
        })
    });

    const operationLogoSize = 120;

    return (
        <AgTechQueryLoadingSurface
            query={operationDataQuery}
            loading={{
                showLoadingText: false
            }}
        >
            {(operation) => (
                <div className='row-based stretched items-center flex'>
                        <div className="bordered rounded-light non-scrollable wide mb-4 flex" style={{ height: operationLogoSize, width: 220 }}>
                        <OperationLogo height={operationLogoSize} width={220} />
                    </div>
                    <h1 className='text-md centered font-semibold text-appSideNavFont flex'>
                        {operation.name}
                    </h1>
                </div>
            )}
        </AgTechQueryLoadingSurface>
    )
}

export default OperationSideNavigationInfo